module.exports = "##### Red\n"